import React from 'react'
import {ReactComponent as ArrowIcon} from "../../../../../assets/Icons/Pages/Organizational/Management/Activities/ShortLinkArrow.svg"
import "../../../../../styles/ComponentsStyles/Organizational/Management/Activities/ShortLinkCard.style.css"
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
const ShortLinkCard = ({ title, description, path, cardColor }) => {
    return (
        <Link to={path} className="shortLinkCard" target="_blank" style={{backgroundColor:cardColor}}>
            <div className="shortLinkDetails">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
            <ArrowIcon fill='white' />
        </Link>
    )
}

export default ShortLinkCard

ShortLinkCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    cardColor: PropTypes.string.isRequired,
}